import { Instagram, Mail, ArrowUpRight } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#141413] text-[#FBF9F6] pt-24 md:pt-32 pb-10"
    >
      <div className="max-w-7xl mx-auto w-full px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 md:gap-12 pb-16 md:pb-24 border-b border-[#33312E]">
          <div className="col-span-12 md:col-span-6">
            <p className="font-mono-label text-[#B4A087]">Studio Notes</p>
            <p className="mt-6 font-serif-display text-3xl md:text-4xl leading-tight max-w-lg">
              Selective by design. We take on a handful of brands each quarter.
            </p>
            <a
              href="#contact"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-3 border border-[#FBF9F6] px-7 py-4 text-sm hover:bg-[#FBF9F6] hover:text-[#141413] transition-colors"
            >
              Book a Free Consultation
              <ArrowUpRight size={16} strokeWidth={1.5} />
            </a>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="font-mono-label text-[#B4A087]">Navigate</p>
            <ul className="mt-6 space-y-3 text-[#FBF9F6]/85">
              <li>
                <a href="#services" data-testid="footer-nav-services" className="hover:text-[#B4A087]">Services</a>
              </li>
              <li>
                <a href="#philosophy" data-testid="footer-nav-philosophy" className="hover:text-[#B4A087]">Philosophy</a>
              </li>
              <li>
                <a href="#pricing" data-testid="footer-nav-pricing" className="hover:text-[#B4A087]">Pricing</a>
              </li>
              <li>
                <a href="#work" data-testid="footer-nav-work" className="hover:text-[#B4A087]">Our Work</a>
              </li>
              <li>
                <a href="#contact" data-testid="footer-nav-contact" className="hover:text-[#B4A087]">Contact</a>
              </li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="font-mono-label text-[#B4A087]">Elsewhere</p>
            <ul className="mt-6 space-y-3">
              <li>
                <a
                  href="https://www.instagram.com/whitneyjeanco/"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-instagram-link"
                  className="inline-flex items-center gap-2 text-[#FBF9F6]/85 hover:text-[#B4A087]"
                >
                  <Instagram size={16} strokeWidth={1.5} /> @whitneyjeanco
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@whitneyjeanco.ca"
                  data-testid="footer-email-link"
                  className="inline-flex items-center gap-2 text-[#FBF9F6]/85 hover:text-[#B4A087]"
                >
                  <Mail size={16} strokeWidth={1.5} /> info@whitneyjeanco.ca
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Massive wordmark */}
        <div className="pt-14 md:pt-20 overflow-hidden">
          <p
            aria-hidden
            className="font-serif-display leading-[0.85] tracking-tighter text-[16vw] md:text-[13vw] whitespace-nowrap"
          >
            Whitney Jean <span className="italic text-[#B4A087]">&amp; Co.</span>
          </p>
        </div>

        <div className="mt-12 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-[#FBF9F6]/50 font-mono-label">
          <p>© {year} Whitney Jean &amp; Co. All rights reserved.</p>
          <p>Marketing · Social Media · Design · whitneyjeanco.ca</p>
        </div>
      </div>
    </footer>
  );
}
